module.exports = __webpack_public_path__ + "static/media/IMG_0430.655cf0cd.HEIC";